define("ExternalVendor.Inventory.EntryPoint", [
  "ExternalVendor.Inventory.View",
  "ExternalVendor.Inventory.SS2Model",
  "SDB.SDBLocations.Model",
  "LiveOrder.Model",
  "Cart.Summary.View",
  "Cart.Lines.View",
  "Cart.Detailed.View",
  "ProductDetails.QuickView.View",
  "Cart.AddToCart.Button.View",
  "Header.MiniCart.View",
  "Utils",
], function (
  ExternalVendorInventoryView,
  ExternalVendorInventorySS2Model,
  SDBLocationsModel,
  LiveOrderModel,
  CartSummary,
  CartLinesView,
  CartDetailedView,
  ProductDetailsQuickView,
  CartAddToCartButton,
  HeaderMiniCart,
  Utils
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {PDPComponent} */
      var PDP = container.getComponent("PDP");
      var itemInfoStatic = null;

      /** @type {LocationsModel} */
      var LocationsModel = SDBLocationsModel.getInstance();
      var Model = ExternalVendorInventorySS2Model.getInstance();
      var recordTypesWithInventory = Model.recordTypesWithInventory;
      var recordTypesNotPurchasable = Model.recordTypesNotPurchasable;

      var Layout = container.getComponent("Layout");
      var env = container.getComponent("Environment");
      LocationsModel.on("change:location", function () {
        var itemInfo = PDP.getItemInfo();
        var item = (itemInfo && itemInfo.item) || itemInfoStatic;
        if (!item) return;
        // var Model = ExternalVendorInventorySS2Model.getInstance();
        updateInternalStock(item, Model);
      });
      LocationsModel.on("change:shoppingExperience", function () {
        if (LocationsModel.getShoppingExperience() == "online") {
          LocationsModel.removeLocation();
          var item = itemInfoStatic;
          if (!item) return;
          // var Model = ExternalVendorInventorySS2Model.getInstance();
          updateInternalStock(item, Model);
        }
      });
      if (Layout) {
        var firstload = true;
        Layout.on("afterShowContent", function () {
          if (!firstload) return;
          firstload = false;
          var data = updateAllLinesModel();
          if (!data || !data.length) return;
          Model.getExternalInventory(data).then(function () {
            updateExternalInventory(data);
          });
        });
      }
      var getCurrentLocation = function getCurrentLocation(doMapping) {
        var selectedLocation = LocationsModel.getSelectedLocation();
        var selectedLocationName = selectedLocation
          ? selectedLocation.name
          : "Fedco";

        if (selectedLocationName === "FT. Sask" && doMapping) {
          selectedLocationName = selectedLocationName.replace(
            "Sask",
            "Saskatchewan"
          );
        }
        return selectedLocationName;
      };

      var map = LocationsModel.getFieldMapper(env);
      var changedStorage = false;

      if (PDP) {
        var selectedLocationName = getCurrentLocation(true);

        PDP.on("beforeShowContent", function () {
          var itemInfo = PDP.getItemInfo();
          var item = itemInfo && itemInfo.item;
          if (!itemInfo || !item) return;
          // in case customer closes the modal without setting any experience in PDP we set it as online
          // To use fedco locations for the requests
          if (LocationsModel.getShoppingExperience() == "") {
            LocationsModel.set("shoppingExperience", "online");
          }

          if (!itemInfoStatic) itemInfoStatic = item;
          var sku = item.itemid;
          var group = item.custitemrs_brand;
          var itemRecordType = item.itemtype;
          if (
            recordTypesWithInventory.indexOf(itemRecordType.toLowerCase()) ===
            -1
          )
            return;

          var data = {
            Group: group,
            GroupIdentifier: sku,
            selectedLocation: selectedLocationName,
            isPDP: true,
          };
          Model.getExternalInventory([data])
            .then(function (response) {
              var requiredInternalStock = getInternalStocks(item);
              var itemMissingStock = {
                sku: sku,
                item_id: item.internalid,
                selectedLocation: getCurrentLocation(true),
                quantity: 0,
                askedLocations: JSON.stringify(requiredInternalStock),
                externalLocations: JSON.stringify(
                  Model.get("externalLocationsPDP")
                ),
                isPDP: true,
              };
              if (!env.isPageGenerator()) {
                Model.getInternalInventory([itemMissingStock]).catch(
                  console.error
                );
              }
            })
            .catch(console.error);
          updateInternalStock(item, Model);
        });

        PDP.addChildViews(PDP.PDP_FULL_VIEW, {
          "Product.Price": {
            "ExternalVendor.Inventory": {
              childViewIndex: 10,
              childViewConstructor: function childViewConstructor() {
                return new ExternalVendorInventoryView({
                  container: container,
                });
              },
            },
          },
        });

        PDP.addChildViews(PDP.PDP_QUICK_VIEW, {
          "Product.Price": {
            "SDB.Inventory": {
              childViewIndex: 10,
              childViewConstructor: function childViewConstructor() {
                return new ExternalVendorInventoryView({
                  container: container,
                });
              },
            },
          },
        });

        if (PDP.PDP_QUICK_VIEW) {
          ProductDetailsQuickView.prototype.initialize = _.wrap(
            ProductDetailsQuickView.prototype.initialize,
            function (fn) {
              fn.apply(this, _.toArray(arguments).slice(1));
              var updateStock = function updateStock() {
                var totalStock = Model.get("totalStock");
                var itemInfo = PDP.getItemInfo();
                if (!itemInfo) return;
                var hidePrice = itemInfo.item.custitem_sdb_item_hide_price;
                if (!totalStock) {
                  var stockField = getInternalStockField();
                  totalStock = itemInfo.item[stockField];
                  if (!totalStock) totalStock = 0;
                }
                var quantity = itemInfo.quantity;
                $('[id*="product-details-quickview-add-to-cart"]').addClass(
                  "hide"
                );
                if (!(quantity > totalStock) && !hidePrice) {
                  $(
                    '[id*="product-details-quickview-add-to-cart"]'
                  ).removeClass("hide");
                }
              };
              this.listenTo(Model, "change:totalStock", updateStock);
              this.render = _.wrap(this.render, function (func) {
                setTimeout(function () {
                  updateStock();
                }, 0);
                return func.apply(this, _.toArray(arguments).slice(1));
              });
            }
          );
          ProductDetailsQuickView.prototype.getContext = _.wrap(
            ProductDetailsQuickView.prototype.getContext,
            function (fn) {
              var context = fn.apply(this, _.toArray(arguments).slice(1));
              var externalStock = Model.attributes.totalStock;
              var itemRecordType = context.model.get("item").get("itemtype");
              if (
                recordTypesNotPurchasable.indexOf(
                  itemRecordType.toLowerCase()
                ) !== -1
              ) {
                context.addToCartEnabled = false;
                return context;
              }
              if (
                recordTypesWithInventory.indexOf(
                  itemRecordType.toLowerCase()
                ) === -1
              ) {
                context.addToCartEnabled = true;
                return context;
              }
              var internalStock = Model.attributes.itemInternalStock[0].stock;
              if (internalStock && externalStock)
                context.addToCartEnabled = true;
              return context;
            }
          );

          CartAddToCartButton.prototype.getContext = _.wrap(
            CartAddToCartButton.prototype.getContext,
            function (fn) {
              var context = fn.apply(this, _.toArray(arguments).slice(1));
              context.isQuickView = true;
              return context;
            }
          );

          PDP.on("afterQuantityChange", function () {
            var totalStock = Model.get("stockBehaviorDataTotalStock");
            if (!totalStock) totalStock = 0;
            var itemInfo = PDP.getItemInfo();
            if (!itemInfo) return;
            var itemRecordType = itemInfo.item.itemtype;
            if (
              recordTypesNotPurchasable.indexOf(
                itemRecordType.toLowerCase()
              ) !== -1
            ) {
              $('[id*="product-details-quickview-add-to-cart"]').addClass(
                "hide"
              );
              return;
            }
            if (
              recordTypesWithInventory.indexOf(itemRecordType.toLowerCase()) ===
              -1
            )
              return;
            var quantity = itemInfo.quantity;
            var hidePrice = itemInfo.item.custitem_sdb_item_hide_price;
            $('[id*="product-details-quickview-add-to-cart"]').addClass("hide");
            if (!(quantity > totalStock) && !hidePrice) {
              $('[id*="product-details-quickview-add-to-cart"]').removeClass(
                "hide"
              );
            }
          });
        }
      }

      /** @type {CartComponent} */
      var Cart = container.getComponent("Cart");
      /** @type {LiveOrder.Model} */
      var LiveOrder = LiveOrderModel.getInstance();

      var updateInternalStock = function updateInternalStock(item, Model) {
        var item_id = item.internalid;
        var internalStockField = getInternalStockField();
        var internalStock = item[internalStockField] || 0;
        if (Model) {
          Model.set("itemInternalStock", [
            {
              item_id: item_id,
              stock: internalStock,
            },
          ]);
        } else {
          return internalStock;
        }
      };

      var getUsedAmount = function getUsedAmount(options) {
        var stock = options.stock,
          toUse = options.toUse;
        var calculation = stock - (stock + toUse);
        return calculation > stock ? stock : calculation;
      };

      var mapWarehouseList = function mapWarehouseList(
        vendors,
        missingInventory,
        final_arr,
        time,
        time_id,
        data,
        type
      ) {
        if (!_.isArray(vendors)) return [];
        for (var i = 0; i < vendors.length; i++) {
          var vendor = vendors[i];
          var availableStock = vendor.availableStock;

          var usedStock = getUsedAmount({
            stock: availableStock,
            toUse: missingInventory,
          });
          if (usedStock == 0) {
            missingInventory = 0;
            break;
          }
          if (type == "external")
            var warehouseData = {
              warehouseId: vendor.warehouseId,
              rs_id: vendor.rs_id,
              availableStock: vendor.availableStock,
              used_stock: usedStock,
              vendor_name: vendor.name,
              vendor_price: parseInt(vendor.price),
              shipping_eta: {
                text: time,
                value: parseInt(time_id),
              },
              itemData: {
                Group: data.Group,
                GroupIdentifier: data.GroupIdentifier,
                itemClass: data.itemClass,
              },
            };
          else
            var warehouseData = {
              availableStock: vendor.availableStock,
              used_stock: usedStock,
              vendor_name: vendor.name,
              vendor_price: parseInt(vendor.price),
              vendor_location: vendor.vendor,
              shipping_eta: {
                text: time,
                value: parseInt(time_id),
              },
              itemData: {
                Group: data.selectedLocation,
                sku: data.sku,
                // itemClass: data.itemClass
              },
            };

          final_arr.push(warehouseData);
          missingInventory += availableStock;

          if (missingInventory >= 0) {
            missingInventory = 0;
            break;
          }
        }

        return missingInventory;
      };

      var mapInventory = function mapInventory(missingInventory, sku, type) {
        var inventory;
        var data;
        if (type == "external") {
          if (Model.get("externalLocations")[0]) {
            for (
              var i = 0;
              i < Object.keys(Model.attributes.externalLocations).length;
              i++
            ) {
              if (
                Model.get("externalLocations")[i] &&
                Model.get("externalLocations")[i].data[0] &&
                Model.get("externalLocations")[i].data[0].GroupIdentifier == sku
              ) {
                var modelData = Model.get("externalLocations")[i];
                inventory = modelData.filteredGroupedLocations;
                data = modelData.data;
                break;
              } else if (!Model.get("externalLocations")[i]) {
                break;
              }
            }
          } else {
            inventory = Model.get("externalLocations").filteredGroupedLocations;
            data = Model.get("externalLocations").data;
          }
        } else if (type == "internal") {
          if (Model.get("internalLocations")[0]) {
            for (
              var i = 0;
              i < Object.keys(Model.attributes.internalLocations).length;
              i++
            ) {
              if (
                Model.get("internalLocations")[i] &&
                Model.get("internalLocations")[i].data[0] &&
                Model.get("internalLocations")[i].data[0].sku == sku
              ) {
                var modelData = Model.get("internalLocations")[i];
                inventory = modelData.filteredGroupedLocations;
                data = modelData.data;
                break;
              } else if (!Model.get("internalLocations")[i]) {
                break;
              }
            }
          } else {
            inventory = Model.get("internalLocations").filteredGroupedLocations;
            data = Model.get("internalLocations").data;
          }
        }
        if (!inventory)
          return { mappedInventory: [], missingInventory: missingInventory };
        if (!data || !data.length)
          return { mappedInventory: [], missingInventory: missingInventory };
        var missingInventory = missingInventory;
        var mappedWarehouses = [];
        for (var i = 0; i < inventory.length; i++) {
          var obj = inventory[i];
          var newMissingInventory = mapWarehouseList(
            obj.vendors,
            missingInventory,
            mappedWarehouses,
            obj.time,
            obj.time_id,
            data[0],
            type
          );
          missingInventory = newMissingInventory;
          if (missingInventory == 0) break;
        }
        return {
          mappedInventory: mappedWarehouses,
          missingInventory: missingInventory,
        };
      };

      var getInventoryJson = function getInventoryJson() {
        var extInventoryJson = localStorage.getItem(
          "custbody_sdb_store_ext_inv_data"
        );

        if (typeof extInventoryJson === "string") {
          extInventoryJson = JSON.parse(extInventoryJson);
        } else if (!extInventoryJson) {
          extInventoryJson = {};
        }

        return extInventoryJson;
      };

      var getInternalInventoryJson = function getInternalInventoryJson() {
        var intInventoryJson = localStorage.getItem(
          "custbody_sdb_store_int_inv_data"
        );

        if (typeof intInventoryJson === "string") {
          intInventoryJson = JSON.parse(intInventoryJson);
        } else if (!intInventoryJson) {
          intInventoryJson = {};
        }

        return intInventoryJson;
      };

      var setInventoryJson = function setInventoryJson(data) {
        var inventoryJson =
          typeof data === "string" ? data : JSON.stringify(data);
        localStorage.setItem("custbody_sdb_store_ext_inv_data", inventoryJson);
      };

      var setInternalInventoryJson = function setInternalInventoryJson(data) {
        var inventoryJson =
          typeof data === "string" ? data : JSON.stringify(data);
        localStorage.setItem("custbody_sdb_store_int_inv_data", inventoryJson);
      };

      var getInternalStockField = function getInternalStockField() {
        var selectedLocationName = getCurrentLocation(false).toUpperCase();
        var internalLocationField = map[selectedLocationName]
          ? map[selectedLocationName].internal
          : "custitem_fedco_int_ecomm_inv";
        return internalLocationField;
      };

      var getInternalStocks = function getInternalStocks(item) {
        var internalStocks = [];
        _.each(map, function (location, locationName) {
          var locationInternal = location.internal;
          var internalStock = item.attributes
            ? item.get(locationInternal) || 0
            : item[locationInternal] || 0;
          if (internalStock == 0) return;
          if (locationName == getCurrentLocation(false).toUpperCase()) return;
          internalStocks.push({
            Location: locationName,
            fieldId: locationInternal,
            internalStock: internalStock,
          });
        });
        return internalStocks; //.sort(function (a, b) { return (a.internalStock - b.internalStock)*-1 });
      };

      var updateLineInventory = function updateLineInventory(data, itemModel) {
        var extInventoryJson = getInventoryJson();
        var newIntJson = getInternalInventoryJson();
        if (data) {
          var line_id = data.result ? data.result : data.line.internalid;
          var item_id = data.line.item.internalid;
          var quantity = data.line.quantity;

          var line = LiveOrder.get("lines").get(line_id);
          var item = line.getItem();
        } else if (itemModel) {
          var item = itemModel.item;
          var quantity = itemModel.quantity;
          var item_id = item.get("internalid");
        }

        var internalStockField = getInternalStockField();
        var internalStock = item.get(internalStockField) || 0;
        var missingInventory = parseInt(quantity - internalStock, 10) * -1;

        if (missingInventory >= 0) {
          if (_.has(extInventoryJson, item_id)) {
            extInventoryJson = _.omit(extInventoryJson, item_id);
            setInventoryJson(extInventoryJson);
          }
          if (_.has(newIntJson, item_id)) {
            newIntJson = _.omit(newIntJson, item_id);
            setInternalInventoryJson(newIntJson);
          }
          changedStorage = true;
          var change = !Model.get("updatedExternalInventory");
          Model.set("updatedExternalInventory", change);
          return;
        }
        var groupIdentifier = item.get("itemid");
        var _mapInventory = mapInventory(
          missingInventory,
          groupIdentifier,
          "external"
        ),
          mappedInventory = _mapInventory.mappedInventory,
          missingInventory = _mapInventory.missingInventory;

        if (mappedInventory.length) {
          extInventoryJson[item_id] = mappedInventory;
          setInventoryJson(extInventoryJson);
        }

        //If there is missing inventory, save item information
        if (missingInventory !== 0) {
          var requiredInternalStock = getInternalStocks(item);
          if (!requiredInternalStock.length) {
            changedStorage = true;
            var change = !Model.get("updatedExternalInventory");
            Model.set("updatedExternalInventory", change);
            return;
          }
          var itemMissingStock = {
            sku: groupIdentifier,
            item_id: item_id,
            selectedLocation: getCurrentLocation(true),
            quantity: missingInventory,
            askedLocations: JSON.stringify(requiredInternalStock),
            externalLocations: JSON.stringify(Model.get("externalLocations")),
          };
        } else if (_.has(newIntJson, item_id)) {
          newIntJson = _.omit(newIntJson, item_id);
          setInternalInventoryJson(newIntJson);
        }
        if (itemMissingStock) {
          Model.getInternalInventory([itemMissingStock]).then(function (data) {
            delete data.internalLocations[0].data[0].externalLocations;
            var itemInfo = data.internalLocations[0].data[0];
            var item_id = itemInfo.item_id;
            var _mapInventory2 = mapInventory(
              itemInfo.quantity,
              itemInfo.sku,
              "internal"
            ),
              mappedInventory = _mapInventory2.mappedInventory,
              missingInventory = _mapInventory2.missingInventory;
            newIntJson[item_id] = mappedInventory;
            setInternalInventoryJson(newIntJson);

            changedStorage = true;

            // Render dependency
            var change = !Model.get("updatedExternalInventory");
            Model.set("updatedExternalInventory", change);
          });
        } else {
          changedStorage = true;

          // Render dependency
          var change = !Model.get("updatedExternalInventory");
          Model.set("updatedExternalInventory", change);
        }
      };

      var clearLineInventory = function clearLineInventory(data) {
        var line = LiveOrder.get("lines").get(data.line_id);
        var extInventoryJson = getInventoryJson();
        var intInventoryJson = getInternalInventoryJson();
        var item_id = line.get("item").get("internalid");
        var linesWithMissingStock = Model.get("linesWithMissingStock");
        if (
          linesWithMissingStock &&
          _.findWhere(linesWithMissingStock, { item_id: item_id })
        ) {
          linesWithMissingStock = _.without(
            linesWithMissingStock,
            _.findWhere(linesWithMissingStock, { item_id: item_id })
          );
          Model.set("linesWithMissingStock", linesWithMissingStock);
        }
        delete extInventoryJson[item_id];
        delete intInventoryJson[item_id];
        setInventoryJson(extInventoryJson);
        setInternalInventoryJson(intInventoryJson);
      };
      var updateExternalInventory = function updateExternalInventory() {
        var newJson = {};
        var newIntJson = {};
        var itemsMissingStock = [];
        var lines = LiveOrder.get("lines").models;
        // var oldMappedInventory = getInventoryJson();
        // var oldInternalMappedInventory = getInternalInventoryJson();
        var currentLocation = getCurrentLocation(true);
        lines.forEach(function (line, index) {
          //Info of the item
          var item = line.getItem();
          var item_id = item.get("internalid");
          var quantity = line.get("quantity");
          var sku = item.get("itemid");

          //Internal stock for current location
          var internalStockField = getInternalStockField();
          var internalStock = item.get(internalStockField) || 0;

          //Missing inventory
          var missingInventory = parseInt(quantity - internalStock, 10) * -1;
          //If no missing inventory, continue
          if (missingInventory >= 0) return;

          //Acquire warehouses and remaining missing inventory
          var _mapInventory3 = mapInventory(missingInventory, sku, "external"),
            mappedInventory = _mapInventory3.mappedInventory,
            missingInventory = _mapInventory3.missingInventory;
          if (mappedInventory.length) newJson[item_id] = mappedInventory;

          //If there is missing inventory, save item information
          if (missingInventory !== 0) {
            var requiredInternalStock = getInternalStocks(item);
            if (!requiredInternalStock.length) return;
            itemsMissingStock.push({
              sku: sku,
              item_id: item_id,
              selectedLocation: currentLocation,
              quantity: missingInventory,
              askedLocations: JSON.stringify(requiredInternalStock),
            });
          }
        });

        // Set external inventory
        setInventoryJson(newJson);

        // Set other stores inventory for each item
        if (itemsMissingStock.length) {
          itemsMissingStock[0].externalLocations = JSON.stringify(
            Model.get("externalLocations")
          );
          Model.getInternalInventory(itemsMissingStock).then(function (data) {
            delete data.internalLocations[0].data[0].externalLocations;
            data.internalLocations.forEach(function (itemInfo) {
              var item_id = itemInfo.data[0].item_id;
              var _mapInventory4 = mapInventory(
                itemInfo.data[0].quantity,
                itemInfo.data[0].sku,
                "internal"
              ),
                mappedInventory = _mapInventory4.mappedInventory;
              newIntJson[item_id] = mappedInventory;
            });
            setInternalInventoryJson(newIntJson);
            changedStorage = true;
            // Render dependency
            var change = !Model.get("updatedExternalInventory");
            Model.set("updatedExternalInventory", change);
          });
        } else {
          setInternalInventoryJson(newIntJson);
          changedStorage = true;

          // Render dependency
          var change = !Model.get("updatedExternalInventory");
          Model.set("updatedExternalInventory", change);
        }
      };

      var updateAllLinesModel = function updateAllLinesModel() {
        var selectedLocationName = getCurrentLocation(true);
        var shoppingExperience = LocationsModel.getShoppingExperience();
        if (shoppingExperience == "online") selectedLocationName = "Fedco";
        var lines = LiveOrder.get("lines").models;
        var data = [];
        lines.forEach(function (line) {
          var item = line.get("item");
          var group = item.get("custitemrs_brand");
          var groupId = item.get("itemid");
          var itemRecordType = item.get("itemtype");
          if (
            recordTypesWithInventory.indexOf(itemRecordType.toLowerCase()) !==
            -1
          )
            data.push({
              Group: group,
              GroupIdentifier: groupId,
              selectedLocation: selectedLocationName,
            });
        });
        return data;
      };

      HeaderMiniCart.prototype.initialize = _.wrap(
        HeaderMiniCart.prototype.initialize,
        function (fn) {
          fn.apply(this, _.toArray(arguments).slice(1));
          var self = this;
          this.listenTo(Model, "change:updatedExternalInventory", function () {
            self.render();
          });
        }
      );

      HeaderMiniCart.prototype.getContext = _.wrap(
        HeaderMiniCart.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          var cartLines = context.model.get("lines")
            ? context.model.get("lines").models
            : [];
          if (!cartLines) return context;
          var extInventoryJson = getInventoryJson();
          var intInventoryJson = getInternalInventoryJson();
          var partialStocks = _.find(cartLines, function (line) {
            var item = line.get("item");
            var internalStockField = getInternalStockField();
            var internalStock = line.getItem().get(internalStockField) || 0;
            var quantity = line.get("quantity");
            var extInventoryData =
              extInventoryJson[item.get("internalid")] || [];
            var intInventoryData =
              intInventoryJson[item.get("internalid")] || [];
            var extInventoryQuantity = !extInventoryData.length
              ? 0
              : extInventoryData.reduce(function (sum, item) {
                return sum + item.used_stock;
              }, 0);
            var intInventoryQuantity = !intInventoryData.length
              ? 0
              : intInventoryData.reduce(function (sum, item) {
                return sum + item.used_stock;
              }, 0);
            var inventory =
              internalStock + extInventoryQuantity + intInventoryQuantity;
            var itemRecordType = item.get("itemtype");
            return (
              quantity > inventory &&
              recordTypesWithInventory.indexOf(itemRecordType.toLowerCase()) !=
              -1
            );
          });
          if (partialStocks) context.partialStocks = true;
          // var linesWithMissingStock = Model.get("linesWithMissingStock") || [];
          // if (linesWithMissingStock.length > 0) {
          //     context.partialStocks = true;
          // }
          return context;
        }
      );

      if (Cart) {
        Cart.on("afterAddLine", function (data) {
          Model.getExternalInventory(updateAllLinesModel()).then(function () {
            updateLineInventory(data);
          });
        });
        Cart.on("afterUpdateLine", function (data) {
          Model.getExternalInventory(updateAllLinesModel()).then(function () {
            updateLineInventory(data);
          });
        });
        Cart.on("beforeRemoveLine", clearLineInventory);
        Cart.on("beforeShowContent", function () {
          var data = updateAllLinesModel();
          if (!data || !data.length) return;
          Model.getExternalInventory(data).then(function () {
            updateExternalInventory();
          });
        });

        LocationsModel.on({
          "change:location": function changeLocation() {
            if (LocationsModel.getShoppingExperience() == "online") return;
            var data = updateAllLinesModel();
            if (!data || !data.length) return;
            Model.getExternalInventory(data).then(function () {
              updateExternalInventory();
            });
          },
          "change:shoppingExperience": function changeShoppingExperience() {
            if (LocationsModel.getShoppingExperience() == "online") {
              var data = updateAllLinesModel();
              if (!data || !data.length) return;
              Model.getExternalInventory(data).then(function () {
                updateExternalInventory();
              });
            }
          },
        });
        CartSummary.prototype.initialize = _.wrap(
          CartSummary.prototype.initialize,
          function (fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            var self = this;
            this.listenTo(
              Model,
              "change:updatedExternalInventory",
              function () {
                self.render();
              }
            );
            this.changedStorage = false;
          }
        );

        CartSummary.prototype.getContext = _.wrap(
          CartSummary.prototype.getContext,
          function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));

            // backward compatibility with SDBSelectYourVehicle customization
            // /Workspace/SDBSelectYourVehicle/Modules/SDBSelectYourVehicle/Templates/ccaw_go_to_checkout_cart_summary_button.tpl
            Model.set("showProceedButton", context.showProceedButton);

            var otherCharges = Number(Model.get("otherCharges")) || 0;
            var serviceCharges = Number(Model.get("serviceCharges")) || 0;
            context.summary.total_formatted = Utils.formatCurrency(
              context.summary.total +
              otherCharges +
              serviceCharges -
              (context.summary.shippingcost ||
                context.summary.estimatedshipping)
            );
            context.useExternalInventory =
              _.isEmpty(getInventoryJson()) &&
                _.isEmpty(getInternalInventoryJson())
                ? false
                : true;
            if (!changedStorage) {
              var linesWithMissingStock =
                Model.get("linesWithMissingStock") || [];
              if (linesWithMissingStock.length) {
                context.partialStocks = true;
                $(".cart-detailed-proceed-to-checkout").addClass("disabled");
              } else {
                $(".cart-detailed-proceed-to-checkout").removeClass("disabled");
              }

              return context;
            }
            var cartLines = context.model.get("lines")
              ? context.model.get("lines").models
              : [];
            if (!cartLines) return context;
            var linesWithMissingStock =
              Model.get("linesWithMissingStock") || [];
            var linesAndStockHelper = Model.get("linesAndStockHelper") || [];
            var extInventoryJson = getInventoryJson();
            var intInventoryJson = getInternalInventoryJson();
            _.each(cartLines, function (line) {
              var item = line.get("item");
              var item_id = item.get("internalid");
              var quantity = line.get("quantity");
              var itemRecordType = item.get("itemtype");
              if (
                recordTypesWithInventory.indexOf(
                  itemRecordType.toLowerCase()
                ) === -1
              ) {
                if (!_.findWhere(linesAndStockHelper, { item_id: item_id })) {
                  linesAndStockHelper.push({
                    item_id: item_id,
                    quantity: quantity,
                    internalStock: quantity,
                    externalStock: 0,
                    otherStock: 0,
                    totalAvailableStock: quantity,
                  });
                } else {
                  // update helper
                  var currentLine = _.findWhere(linesAndStockHelper, {
                    item_id: item_id,
                  });
                  currentLine.quantity = quantity;
                  currentLine.totalAvailableStock = quantity;
                  currentLine.internalStock = quantity;
                  currentLine.externalStock = 0;
                  currentLine.otherStock = 0;
                }
                Model.set("linesAndStockHelper", linesAndStockHelper);
                return;
              }

              var totalExternalUsedStock = 0;
              if (extInventoryJson[item_id]) {
                totalExternalUsedStock = extInventoryJson[item_id].reduce(
                  function (sum, item) {
                    return sum + item.availableStock;
                  },
                  0
                );
              }
              var totalInternalUsedStock = 0;
              if (intInventoryJson[item_id]) {
                totalInternalUsedStock = intInventoryJson[item_id].reduce(
                  function (sum, item) {
                    return sum + item.availableStock;
                  },
                  0
                );
              }
              var internalStockField = getInternalStockField();
              var internalStock = item.get(internalStockField) || 0;
              var totalAvailableStock =
                Number(internalStock) +
                Number(totalExternalUsedStock) +
                Number(totalInternalUsedStock);
              if (!_.findWhere(linesAndStockHelper, { item_id: item_id })) {
                linesAndStockHelper.push({
                  item_id: item_id,
                  quantity: quantity,
                  internalStock: internalStock,
                  externalStock: totalExternalUsedStock,
                  otherStock: totalInternalUsedStock,
                  totalAvailableStock: totalAvailableStock,
                });
              } else {
                // update helper
                var currentLine = _.findWhere(linesAndStockHelper, {
                  item_id: item_id,
                });
                currentLine.quantity = quantity;
                currentLine.totalAvailableStock = totalAvailableStock;
                currentLine.internalStock = internalStock;
                currentLine.externalStock = totalExternalUsedStock;
                currentLine.otherStock = totalInternalUsedStock;
              }
              Model.set("linesAndStockHelper", linesAndStockHelper);
              if (quantity > totalAvailableStock) {
                !_.findWhere(linesWithMissingStock, { item_id: item_id }) &&
                  linesWithMissingStock.push({
                    item_id: item_id,
                    quantity: quantity,
                    totalAvailableStock: totalAvailableStock,
                  });
                Model.set("linesWithMissingStock", linesWithMissingStock);
              } else {
                if (_.findWhere(linesWithMissingStock, { item_id: item_id })) {
                  linesWithMissingStock = _.without(
                    linesWithMissingStock,
                    _.findWhere(linesWithMissingStock, { item_id: item_id })
                  );
                  Model.set("linesWithMissingStock", linesWithMissingStock);
                }
              }
            });
            if (linesWithMissingStock.length > 0) {
              context.partialStocks = true;
              $(".cart-detailed-proceed-to-checkout").addClass("disabled");

              // backward compatibility with SDBSelectYourVehicle customization
              // /Workspace/SDBSelectYourVehicle/Modules/SDBSelectYourVehicle/Templates/ccaw_go_to_checkout_cart_summary_button.tpl
              Model.set("partialStocks", context.partialStocks);
            } else {
              $(".cart-detailed-proceed-to-checkout").removeClass("disabled");

              // backward compatibility with SDBSelectYourVehicle customization
              // /Workspace/SDBSelectYourVehicle/Modules/SDBSelectYourVehicle/Templates/ccaw_go_to_checkout_cart_summary_button.tpl
              Model.set("partialStocks", false);
            }
            changedStorage = false;
            return context;
          }
        );

        _.extend(CartLinesView.prototype, {
          //CartLinesView
          initialize: _.wrap(CartLinesView.prototype.initialize, function (fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            this.addChildViews();
            var self = this;
            this.listenTo(
              Model,
              "change:updatedExternalInventory",
              function () {
                self.childViewInstances["ExternalVendor.Inventory"][
                  "ExternalVendor.Inventory"
                ].childViewInstance.render();
              }
            );
          }),
          addChildViews: function addChildViews() {
            // Adding the child view to each cart line
            this.addChildViewInstances({
              "ExternalVendor.Inventory": function ExternalVendorInventory() {
                return new ExternalVendorInventoryView({
                  container: container,
                  cartpage: true,
                  extInventoryJson: getInventoryJson(), // Pass any additional data needed
                  cartLine: this.model.get("item"), // Pass the cart line model to access stock
                });
              },
            });
          },
        });
      }
    },
  };
});
